import { Phone } from "lucide-react";
import { FaWhatsapp } from "react-icons/fa";
import { SITE, waLink } from "../data/site";
import { useLang } from "../i18n";
import Reveal from "./Reveal";

export default function CtaBand({ title, text }) {
  const { t } = useLang();
  return (
    <section className="max-w-7xl mx-auto px-6 py-16">
      <Reveal>
        <div className="relative overflow-hidden rounded-3xl bg-royal grain px-8 py-14 sm:px-14 text-center">
          <div className="gold-line absolute top-0 left-0 right-0" />
          <h2 className="font-heading text-3xl sm:text-4xl font-extrabold text-white tracking-tight">{title || t("ctaTitle")}</h2>
          <p className="mt-3 text-white/75 max-w-xl mx-auto text-sm sm:text-base">{text || t("ctaText")}</p>
          <div className="mt-8 flex flex-wrap justify-center gap-3">
            <a href={`tel:${SITE.phoneTel}`} data-testid="ctaband-call-btn" className="inline-flex items-center gap-2 rounded-full bg-gold text-navy font-bold px-7 py-3.5 text-sm hover:bg-white transition-colors">
              <Phone size={16} /> {t("stickyCall")} {SITE.phoneDisplay}
            </a>
            <a href={waLink()} target="_blank" rel="noopener noreferrer" data-testid="ctaband-whatsapp-btn" className="inline-flex items-center gap-2 rounded-full bg-wa text-white font-bold px-7 py-3.5 text-sm hover:brightness-95 transition">
              <FaWhatsapp size={17} /> {t("whatsappNow")}
            </a>
          </div>
        </div>
      </Reveal>
    </section>
  );
}
